<template>
  <div class="index">
    <div class="btn-group">
      <div @click="clickJoin" class="btn-orange">点击参与领红包</div>
      <div @click="showDetail=true" class="btn-text"><span class="icon-wh">?</span>活动规则</div>
    </div>
    <div @click="clickCZFW" class="CZFW">
      <img src="https://gw.alipayobjects.com/os/q/cms/images/jkb8jwhz/48bdb4f6-bcf0-4353-a359-d6ac06983997_w116_h89.png" alt="">
    </div>
    <com-detail :show.sync="showDetail"></com-detail>
    <com-share></com-share>
  </div>
</template>

<script>
import Axios from 'axios'
import ComStep from '../components/step.vue'
import ComSteps from '../components/steps.vue'
import ComDetail from '../components/detail.vue'
import ComShare from '../components/share.vue'
export default {
  name: 'index',
  data() {
    return {
      cat: 'cat',
      showDetail: false
    }
  },
  created() {
    if (ENV == 'prod') {
      if (!window.AlipayJSBridge && location.host == 'cat.pangku.com') {
        location.href = `https://car.pcauto.com.cn/pangku/cat/dist/cs180824/index.html${location.search}`
        return
      }
      if (window.AlipayJSBridge && location.host == 'car.pcauto.com.cn') {
        location.href = `https://cat.pangku.com/dist/cs180824/index.html${location.search}`
        return
      }
    }
    if (ENV != 'prod') {
      this.cat = 'at'
    }
    if (this.getQueryString('cfrom') == 'other') {
      this.clickJoin()
    }
  },
  methods: {
    clickJoin() {
      const now = Date.now()
      const startTime = new Date(2018, 8, 1, 0, 0, 0)
      const endTime = new Date(2018, 8, 8, 0, 0, 0)
      console.log(now)
      console.log(startTime)
      console.log(endTime)
      // if (now < startTime) {
      //   alert('当前非活动时间,请于9月1日前往体验,敬请期待!')
      //   return
      // } else if (now > endTime) {
      //   alert('活动已结束')
      //   return
      // }
      /* eslint-disable no-undef */
      _hmt.push(['_trackEvent', '垂搜', '跳转按钮', this.getQueryString('mid')])
      if (!window.AlipayJSBridge) {
        const url = `https://${this.cat}.pangku.com/dist/cs180824/index.html?${location.search.slice(1)}&cfrom=other`
        location.href = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(url)}`
        return
      }
      if (!localStorage.getItem('isJoin')) {
        this.$loading.show()
        Axios({
          url: `https://${this.cat}.pangku.com/activity/cs180824/invite`,
          params: {
            activity_key: 'cs180824',
            mid: this.getQueryString('mid') || 'YWxpcGF5'
          }
        }).then(result => {
          this.$loading.hide()
          let res = result.data
          if (res.code == 0) {
            localStorage.setItem('isJoin', true)
            if (ENV == 'test') {
              const url = `https://${this.cat}.pangku.com/dist/cs180824/middle.html${location.search}`
              location.href = url
            } else {
              location.href = 'alipays://platformapi/startapp?appId=66666666&chInfo=ch_chengduautoshow'
            }
          } else {
            this.$toast.show(res.msg)
          }
        })
      } else {
        if (ENV == 'test') {
          const url = `https://${this.cat}.pangku.com/dist/cs180824/middle.html${location.search}`
          location.href = url
        } else {
          location.href = 'alipays://platformapi/startapp?appId=66666666&chInfo=ch_chengduautoshow'
        }
      }
    },
    clickCZFW() {
      location.href = 'alipays://platformapi/startapp?appId=20000919&url=https://mycar-vbizplatform.alipay-eco.com/vbizplatform/user/auth?channelType=waibulaiyuan'
    },
    getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var result = window.location.search.substr(1).match(reg)
      return result ? decodeURIComponent(result[2]) : null
    }
  },
  components: {
    ComStep,
    ComSteps,
    ComDetail,
    ComShare
  }
}
</script>

<style lang="scss">
.index {
  background: url('../img/index-bg.jpg') no-repeat;
  background-size: 100% 100%;
  width: 750px;
  height: 2862px;
  overflow: hidden;
  padding-top: 894px;
}
.btn-orange {
  box-shadow: 0 14px 14px #246fdb;
}
.CZFW {
  position: fixed;
  top: 400px;
  right: 0;
  z-index: 999;
  img {
    width: 106px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cs180824/index/Index.vue